import gql from 'graphql-tag'
import { ProfileFieldsFragment } from '../profile'

export { SchoolWithProfileFields as ISchoolWithProfile } from './__generated__/SchoolWithProfileFields'

export const SchoolWithProfileFieldsFragment = gql`
  fragment SchoolWithProfileFields on School {
    profile {
      ...ProfileFields
    }
  }

  ${ProfileFieldsFragment}
`
